interface Props {
    color?: boolean
}

export const FavIcon = ({color = false}: Props) => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36">
            <g id="fav_red" transform="translate(-387 -1207)">
                <rect
                    id="Rectangle_11228"
                    data-name="Rectangle 11228"
                    width="36"
                    height="36"
                    rx="4"
                    transform="translate(387 1207)"
                    fill="#fff"
                    opacity="0"
                />
                <g id="favorite_black_24dp" transform="translate(393 1213)">
                    <path
                        id="Path_46300"
                        data-name="Path 46300"
                        d="M0,0H24V24H0Z"
                        fill="none"
                    />
                    <path
                        id="Path_46301"
                        data-name="Path 46301"
                        d="M13.35,20.13a2,2,0,0,1-2.69-.01l-.11-.1C5.3,15.27,1.87,12.16,2,8.28A5.459,5.459,0,0,1,4.34,3.99,5.8,5.8,0,0,1,12,5.09a5.784,5.784,0,0,1,7.66-1.1A5.459,5.459,0,0,1,22,8.28c.14,3.88-3.3,6.99-8.55,11.76l-.1.09Z"
                        fill={color ? '#f64f64' : '#eaecf2'}
                    />
                </g>
            </g>
        </svg>
    );
};
